import React, { useEffect, useState } from 'react'
import Nav from '../Components/Nav';
import Banner from '../Components/Banner';
import Love from '../Components/Love';
import ProjectList from '../Components/ProjectList';
import ViewProject from '../Components/ViewProject';
import Footer from '../Components/Footer';
import Loader from '../Components/Loader';

function Home() {

  const [showComponent, setShowComponent] = useState(true);

  const isComponentHidden = localStorage.getItem("componentHidden");
  useEffect(() => {

    if (isComponentHidden) {

      setShowComponent(false);
    } else {
      setTimeout(() => {
        setShowComponent(false);
      }, 4000);
      localStorage.setItem("componentHidden", true);
    }
  }, []);


  return (
       showComponent ? <Loader /> :
        <>
          <Nav />
          <Banner />
          <Love />
          <ProjectList />
          <ViewProject />
          <Footer />
        </>
  );
}

export default Home;
